import agent from '../agent';
import Header from './Header';
import React from 'react';
import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { APP_LOAD, TRIPS_LOADED, REDIRECT, GOTOLOGIN, DB_INITIALIZED } from '../constants/actionTypes';
import { Route, Switch } from 'react-router-dom';
import Home from '../components/Home';
import Login from '../components/Login';
import Profile from '../components/Profile';
import Register from '../components/Register';
import Settings from '../components/Settings';
import ViewSite from './Sites/ViewSite.js';
import EditSite from './Sites/EditSite.js';
import NewSite from '../components/Sites/NewSite.js';
import Upload from './Upload.js';
import Banner from './Home/Banner';
import Tabs from './Tabs';
import ListRecords from './Tables/ListRecords';
import ViewRecord from './Tables/ViewRecord';
import NewRecord from './Tables/NewRecord';
import EditRecord from './Tables/EditRecord';
import Sites from './Sites';
import db from '../db';
import { store } from '../store';
import { push } from 'react-router-redux';

const mapStateToProps = state => {
  return {
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    currentUser: state.common.currentUser,
    token: state.common.token,
    tables: state.tables || [],
    sites: state.sites || [],
    users: state.users || [],
    redirectTo: state.common.redirectTo,
  }};

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, token) =>
    dispatch({ type: APP_LOAD, payload, token, skipTracking: true }),
  loadTrips: (payload) =>
    dispatch({ type: TRIPS_LOADED, payload }),
  onRedirect: () =>
    dispatch({ type: REDIRECT }),
  gotoLogin: () =>
    dispatch({ type: GOTOLOGIN }),
  dbInitialized: () =>
    dispatch({ type: DB_INITIALIZED })
});

class App extends React.Component {

  componentDidUpdate(prevProps) {
    if (this.props.tables.length > 0 && prevProps.tables.length == 0) {
      let tables = this.props.tables;
      let users = this.props.users;
      console.log('initializing stores');
      db.initializeDbStores(this.props.tables, db.version)
        .then(res => {
          this.props.dbInitialized();
          console.log('initialized stores');
          tables.forEach(table => {
            db.set(table);
          });
          users.forEach(user => {
            user.name = user.fName +' '+user.lName;
            db.set(user, 'users');
          });
        })
        .catch(err => {
          alert('Error occurred. Please use latest Google chrome or other modern browsers');
          console.log(err);
        })
      // setTimeout(() => {
        
      // }, 20);

    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      // this.context.router.replace(nextProps.redirectTo);
      store.dispatch(push(nextProps.redirectTo));
      this.props.onRedirect();
    }
  }

  componentWillMount() {
    const token = window.localStorage.getItem('jwt');
    let userDetails;
    console.log('token');
    if (token && token.length > 0) {
      console.log('inside token');
      agent.setToken(token);
      userDetails = jwtDecode(token);
      console.log(userDetails.exp, Math.floor(Date.now()/1000));
      if(userDetails.exp < Math.floor(Date.now()/1000)) {
        this.props.gotoLogin();
      }else {
        agent.setToken(token);
        this.props.onLoad(token ? agent.Auth.current() : null, token);
      }
    }else {
      console.log('insde no token');
      this.props.gotoLogin();
    }

    //Create new endpoint in the API to validate token and get user details if token is present
    //this.props.onLoad(token ? userDetails : null, token);
    //const tripPromise = agent.Trips.getAll;
    //this.props.loadTrips(Promise.all([tripPromise()]));
  }

  render() {
    if (this.props.appLoaded) {
      return (
        <div>
          <Header
            appName={this.props.appName}
            currentUser={this.props.currentUser} />
          <Banner 
            token={this.props.token} 
            appName={this.props.appName} />
          <Tabs 
            token={this.props.token} 
            tables={this.props.tables}/>
          
          <Switch>
            <Route exact path="/" component={Home}/>
            <Route path="/login" component={Login} />
            <Route path="/register" component={Register} />
            <Route path="/settings" component={Settings} />
            <Route path="/@:username" component={Profile} />
            <Route path="/upload" component={Upload} />
            <Route path="/sites/:siteId/edit" component={EditSite} />
            <Route path="/sites/:siteId/view" component={ViewSite} />
            <Route path="/sites/new" component={NewSite} />
            <Route path="/sites" component={Sites} />
            <Route path="/table/:tableId/:dataId/edit" component={EditRecord} />
            <Route path="/table/:tableId/:dataId/view" component={ViewRecord} />
            <Route path="/table/:tableId/new" component={NewRecord} />
            <Route path="/table/:tableId/list" component={ListRecords} />
          </Switch>
        </div>
      );
    }
    return (
      <div>
        <Header
          appName={this.props.appName}
          currentUser={this.props.currentUser} />
      </div>
    );
  }
}

// App.contextTypes = {
//   router: PropTypes.object.isRequired
// };

export default connect(mapStateToProps, mapDispatchToProps)(App);
